import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";

import styles from "../terminalSolution.module.scss";

type InstallationInfoProps = {
	sectionName?: string;
	isLoading?: boolean;
};

const InstallationInfo = ({
	sectionName = "installation",
	isLoading = false,
}: InstallationInfoProps) => {
	const { register } = useFormContext();

	return (
		<div data-autotest="installationInfoSection">
			<p className={styles.title}>Installation Info</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id="auroraInstall"
						register={register}
						name={`${sectionName}.terminalInstall`}
						value="1"
						label="Aurora Install"
						blurLoading={isLoading}
						className={styles.radioButton}
					/>
				</Col>
				<Col md={4}>
					<HookFormRadioButton
						id="agentInstall"
						register={register}
						name={`${sectionName}.terminalInstall`}
						value="2"
						label="Agent Install"
						blurLoading={isLoading}
						className={styles.radioButton}
					/>
				</Col>
			</Row>
			<Row className="form-group">
				<Col>Best Time To Call (Pacific Time)</Col>
			</Row>
			<Row className="form-group">
				<Col md={2} className="pr-0">
					<HookFormRadioButton
						id="bestTimeToCallAM"
						register={register}
						name={`${sectionName}.bestTimeToCall`}
						value="am"
						label="AM (07:00-11:00)"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={4}>
					<HookFormRadioButton
						id="bestTimeToCallPM"
						register={register}
						name={`${sectionName}.bestTimeToCall`}
						value="pm"
						label="PM (13:00-17:00)"
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default InstallationInfo;
